import React, { useEffect, useState } from "react";
import "./Skills.css";
import { data } from "./data";
import { SkillSet } from "./data-v2";
import { useScreenColumns } from "../../hooks/useScreenColumns"

const Threshold = 991;

const Box = ({ children }) => {
  return <div className="box" style={{
    width: '100%',
    height: 90,
    margin: 4,
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontSize: 16,
  }}>{children}</div>
}

export const Skills = () => {
  const [skills, setSklls] = useState(data);
  const [category, setCategory] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);

  const columns = useScreenColumns()

  useEffect(() => {
    let set = new Set();
    data.map((skill) => {
      set.add(skill.category);
    });

    setCategory(Array.from(set));
  }, []);

  useEffect(() => {
    const listener = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => window.removeEventListener("resize", listener);
  });

  return (
    <section className="skillsContainer">
      <h1>
        Skills
        <div className="bottomLine"></div>
      </h1>
      <div className="skillWrap">
        {/* {category.map((c, index) => {
          return (
            <div key={index} className="skillCard">
              <div className="skillCardIntro">{c}</div>
              <div className="skillCardContent">
                {skills
                  .filter((skill) => skill.category === c)
                  .map((skill, index) => {
                    return (
                      <div key={index} id="skillBean">
                        <h5>{skill.name}</h5>
                        {width > Threshold && (
                          <span>Years of experience: {skill.experience}</span>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })} */}

      </div>

      <div className="boxContainer" style={{ display: 'grid', padding: 12, gap: 48, gridTemplateColumns: `repeat(${columns}, minmax(130px, 1fr))` }}>
        {
          SkillSet.map((skill, index) => {
            return <Box key={index}>
              {skill.icon}
              {skill.name}
            </Box>
          })
        }
      </div>

      <div style={{ height: "100px" }}></div>
    </section >
  );
};
